export enum Status {
  ERROR = 'error',
  SUCCESS = 'success',
  WARNING = 'warning',
  DEFAULT = 'default',
}
